import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-heart-pulse-line',
    accentColor: '#FF8C69',
    tag: '個人保障',
    title: '個人醫療保險',
    desc: '協助規劃住院、手術、實支實付、重大疾病、意外醫療等基礎保障，降低突發醫療費用對生活造成的衝擊。',
    suitable: '上班族、自由工作者、新鮮人、剛開始建立保障的人',
    ctaLabel: '立即諮詢',
    ctaPath: '/contact',
    img: 'https://readdy.ai/api/search-image?query=individual%20health%20medical%20insurance%20planning%20professional%20consultation%20warm%20office%20desk%20documents%20calm%20trustworthy%20atmosphere%20minimal%20clean&width=600&height=380&seq=svc2001&orientation=landscape',
    features: ['住院日額保障', '手術費用補償', '實支實付醫療', '重大疾病保障', '意外醫療保障'],
  },
  {
    icon: 'ri-home-heart-line',
    accentColor: '#5C5470',
    tag: '家庭保障',
    title: '家庭醫療保障',
    desc: '依照家庭成員、收入責任、子女照顧、父母照護等需求，建立家庭整體風險防護網。',
    suitable: '年輕家庭、育兒家庭、雙薪家庭、家庭主要經濟支柱',
    ctaLabel: '預約諮詢',
    ctaPath: '/contact',
    img: 'https://readdy.ai/api/search-image?query=family%20protection%20insurance%20planning%20happy%20asian%20family%20parents%20children%20warm%20home%20environment%20safe%20secure%20lifestyle%20portrait%20natural%20light&width=600&height=380&seq=svc2002&orientation=landscape',
    features: ['家庭成員保障規劃', '收入中斷保障', '子女教育保障', '父母長照規劃', '家庭風險評估'],
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    accentColor: '#D4A373',
    tag: '資產管理',
    title: '資產與風險管理',
    desc: '透過保單健檢、保障缺口分析、現金流與風險承受度評估，協助客戶調整出更穩健的保障架構。',
    suitable: '已有保單但不確定是否足夠者、高資產族、重視長期財務安全者',
    ctaLabel: '下載健檢表',
    ctaPath: '/about#health-check-form',
    img: 'https://readdy.ai/api/search-image?query=financial%20asset%20risk%20management%20analysis%20professional%20advisor%20reviewing%20charts%20graphs%20documents%20modern%20office%20sophisticated%20calm%20atmosphere&width=600&height=380&seq=svc2003&orientation=landscape',
    features: ['保單健檢分析', '保障缺口診斷', '現金流評估', '風險承受度測試', '保障架構優化'],
  },
  {
    icon: 'ri-building-4-line',
    accentColor: '#5C5470',
    tag: '企業方案',
    title: '企業與團體方案',
    desc: '協助企業規劃員工團體保險、健康保障與福利方案，提升員工安心感與企業留才力。',
    suitable: '中小企業主、團隊負責人、人資主管、重視員工福利的企業',
    ctaLabel: '聯絡我們',
    ctaPath: '/contact',
    img: 'https://readdy.ai/api/search-image?query=corporate%20team%20group%20insurance%20employee%20benefits%20planning%20business%20meeting%20professional%20office%20environment%20modern%20clean%20collaborative%20atmosphere&width=600&height=380&seq=svc2004&orientation=landscape',
    features: ['員工團體保險', '健康福利方案', '企業主保障規劃', '員工關懷計畫', '定期方案檢視'],
  },
];

export default function ServicesCards() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-[#D4A373] font-semibold tracking-widest mb-3" style={{ fontSize: '1rem' }}>
            WHAT WE OFFER
          </p>
          <h2
            className="font-serif font-bold text-[#5C5470]"
            style={{ fontSize: 'clamp(1.5rem, 3vw, 2.125rem)', lineHeight: '1.4' }}
          >
            服務總覽
          </h2>
          <div className="w-14 h-1 bg-[#D4A373] mx-auto rounded-full mt-4 mb-6"></div>
          <p className="text-gray-600 max-w-xl mx-auto" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
            不是產品清單，而是人生風險結構規劃
          </p>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="bg-[#F8F5F0] rounded-3xl overflow-hidden border border-transparent hover:border-[#D4A373]/30 transition-all duration-300 hover:-translate-y-1 flex flex-col"
            >
              {/* Image */}
              <div className="h-52 overflow-hidden flex-shrink-0">
                <img
                  src={svc.img}
                  alt={svc.title}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-8 flex flex-col flex-1">
                {/* Tag + Icon */}
                <div className="flex items-center gap-3 mb-5">
                  <div
                    className="w-11 h-11 flex items-center justify-center rounded-xl flex-shrink-0"
                    style={{ backgroundColor: `${svc.accentColor}18` }}
                  >
                    <i className={`${svc.icon} text-xl`} style={{ color: svc.accentColor }}></i>
                  </div>
                  <span
                    className="px-3 py-1 rounded-full font-medium"
                    style={{ fontSize: '1rem', backgroundColor: `${svc.accentColor}15`, color: svc.accentColor }}
                  >
                    {svc.tag}
                  </span>
                </div>

                {/* Title */}
                <h3
                  className="font-serif font-bold text-[#5C5470] mb-4"
                  style={{ fontSize: 'clamp(1.25rem, 2vw, 1.625rem)', lineHeight: '1.45' }}
                >
                  {svc.title}
                </h3>

                {/* Desc */}
                <p className="text-gray-600 mb-5" style={{ fontSize: '1.1875rem', lineHeight: '1.75' }}>
                  {svc.desc}
                </p>

                {/* Features */}
                <div className="flex flex-wrap gap-2 mb-5">
                  {svc.features.map((f) => (
                    <span
                      key={f}
                      className="bg-white border border-gray-200 text-gray-600 px-3 py-1 rounded-full"
                      style={{ fontSize: '1rem' }}
                    >
                      {f}
                    </span>
                  ))}
                </div>

                {/* Suitable */}
                <div className="flex items-start gap-2 mb-7 mt-auto">
                  <i className="ri-user-heart-line text-[#D4A373] mt-0.5 flex-shrink-0"></i>
                  <p className="text-gray-500" style={{ fontSize: '1rem', lineHeight: '1.6' }}>
                    <strong className="text-[#5C5470]">適合對象：</strong>{svc.suitable}
                  </p>
                </div>

                {/* CTA */}
                <Link
                  to={svc.ctaPath}
                  className="inline-flex items-center justify-center gap-2 bg-[#5C5470] text-white px-6 py-3.5 rounded-full font-semibold whitespace-nowrap hover:bg-[#4a4360] transition-all duration-200 self-start"
                  style={{ fontSize: '1.0625rem' }}
                >
                  {svc.ctaLabel}
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
